import React from 'react'
import { Box, Button } from '@mui/material'
import { ReactComponent as CalendarIcon } from '../../../../Assets/img/icons/calendar-icon-figma.svg'

const UpcomingEvents = () => {

    const sampleEvent = {
        date: '25 Jul 2024', //? Must be presented in UI in dd mon yyyy format
        title: 'AI in Web Design Conference \'24',
        desc: 'Explore integrating AI into websites and web apps beyond ChatGPT in UI design.',
        topics: 'Web Design, Artificial Intelligence', //? should be an array of topics; kept as string for simplicity
        mode: 'Virtual'
    } //? fetch the most recent or highest priority event

    const eventDate = sampleEvent.date.split(' ');
    const date = eventDate[0];
    const month = eventDate[1]; // In 3-letter format: Jan, Feb, etc.
    const year = eventDate[2];

  return (
    <Box className='sidefeed-box upcoming-events-box my-2'> 
    <div className='sidefeed-titles d-flex justify-content-between align-items-center pb-3 px-3'>
        <span>Upcoming Events</span>
        <span className='pointer'>VIEW ALL EVENTS</span>
    </div>
    <div className="sidefeed-box-content p-3">
        <div className="upcoming-event">
            <div className="event-date-box-container flex-center">
                <div className="event-date-box">
                <CalendarIcon />
                <div className='event-date text-center'>
                    <div className='event-date-number'>{date}</div>
                    <div className='event-month'>{month}</div>
                    <div className='event-year'>{year}</div>
                </div>
                </div>
            </div>
            <div className="event-details-box d-flex flex-column word-break">
                <div className='event-title mb-1'>{sampleEvent.title}</div>
                <div className='mb-3'>{sampleEvent.desc}</div>
                <div className='mb-1'> <span className='fw-bold'>Topics:</span> {sampleEvent.topics}</div>
                <div> <span className='fw-bold'>Where:</span> {sampleEvent.mode}</div>
                <Button className='my-3' sx={{width: 'fit-content'}}>JOIN</Button>
            </div>
        </div>
    </div>
    </Box>
  )
}

export default UpcomingEvents